import React, { useEffect } from 'react';

import { useService } from '../JOKI';
import { useRedirectToMap } from '../components/Map/useRedirectToMap';
import DeviceGrid from '../components/DeviceGrid/DeviceGrid';
import DeviceDetails from '../components/DeviceDetails/DeviceDetails';
import PageHeader, { usePageHeaderState } from './commons/PageHeader';

import DeviceFilters from '../components/FilterComponents/DeviceFilters';

import './viewBody.scss';
import './layout.scss';
export default function DevicesView(props) {
    //const [devices, trigger, ask, version, previous] = useService("DevicesService");
    const devicesService = useService('DevicesService');
    const devices = devicesService[0];
    const trigger = devicesService[1];
    
    const isLoading = devicesService[3] === null;

    useRedirectToMap(props);
    const [filters, sorters, searchKey, updateAlterState, filteredDevices] = usePageHeaderState({
        filters: [],
        sorters: [
            {
                key: 'alertCount.active.total',
                reverse: true,
                id: 'srule1',
                description: 'Amount of alarms',
            },
            { key: 'name', reverse: false, id: 'srule2', description: 'Device name' },
            { key: 'type', reverse: false, id: 'srule3', description: 'Device type' },
            { key: 'subType', reverse: false, id: 'srule5', description: 'Device subtype' },
            { key: 'isOnline', reverse: false, id: 'srule4', description: 'Device is Online' },
        ],
        search: '',
        searchFromKeys: ['name', 'description', 'type', 'subType'],
        items: devices,
    });

    useEffect(() => {
        trigger({
            key: "updateIntervalSpeed",
            body: "fast",
        });

        return () => {
            trigger({
                key: "updateIntervalSpeed",
                body: "slow",
            }); 
        }
    }, [])

    const totalCount = Array.isArray(devices) ? devices.length : 0;

    return (
        <div className="main-view">
            <PageHeader
                permissions={props.permissions}
                filters={filters}
                sorters={sorters}
                search={searchKey}
                searchDisabled={totalCount === 0}
                onChange={updateAlterState}
                filterComponent={DeviceFilters}
                title="Devices"
            />
            <div className="view-body devices-view">
                <div className="body-list">
                    <DeviceGrid devices={filteredDevices} totalCount={totalCount} loading={isLoading} />
                </div>
                {<DeviceDetails  permissions={props.permissions}/>}
            </div>
        </div>
    );
}
